import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './banner1.css'

const Banner1 = (props) => {
  return (
    <div className="banner1-container10 thq-section-padding">
      <div className="banner1-container11">
        <h1 className="banner1-text10">
          {props.heading ?? (
            <Fragment>
              <span className="banner1-text41">About Allstream Global</span>
            </Fragment>
          )}
        </h1>
        <p className="banner1-text11">
          {props.text ?? (
            <Fragment>
              <span className="banner1-text47">
                {' '}
                At Allstream Global, we don’t just help you start a company — we
                help you run it smarter, leaner, and more profitably. Our
                mission is to simplify business operations in the UAE so
                entrepreneurs, SMEs, and international companies can focus on
                growth, not paperwork.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </Fragment>
          )}
        </p>
        <div className="banner1-container12">
          <div className="banner1-container13">
            <h2 className="banner1-text12">
              {props.heading3 ?? (
                <Fragment>
                  <span className="banner1-text40">Our Story</span>
                </Fragment>
              )}
            </h2>
            <p className="banner1-text13">
              {props.text2 ?? (
                <Fragment>
                  <span className="banner1-text43">
                    <span>
                      {' '}
                      Founded by a team of business operations experts,
                      Allstream Global Business Solutions was created to bridge
                      the gap between complex administrative tasks and seamless
                      business growth.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <span>
                      {' '}
                      We’ve helped various companies streamline HR, finance,
                      procurement, IT, and compliance — all under one roof.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="banner1-container14">
            <div className="banner1-container15"></div>
          </div>
        </div>
        <div className="banner1-container16">
          <div className="banner1-container17">
            <h2 className="banner1-text14">
              {props.heading4 ?? (
                <Fragment>
                  <span className="banner1-text42">Our Mission</span>
                </Fragment>
              )}
            </h2>
            <p className="banner1-text15">
              {props.text3 ?? (
                <Fragment>
                  <span className="banner1-text33">
                    {' '}
                    To empower businesses in the UAE with expert administrative
                    support so they can focus on what matters most: growth,
                    innovation, and profitability.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="banner1-container18">
            <h2 className="banner1-text16">
              {props.heading5 ?? (
                <Fragment>
                  <span className="banner1-text34">Our Vision</span>
                </Fragment>
              )}
            </h2>
            <p className="banner1-text17">
              {props.text4 ?? (
                <Fragment>
                  <span className="banner1-text36">
                    {' '}
                    To become the most trusted partner for businesses in the
                    UAE, offering a one-stop solution for operations,
                    compliance, HR, finance, procurement, IT, and PRO services.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <h2 className="banner1-text18">
          {props.heading2 ?? (
            <Fragment>
              <span className="banner1-text32">Our Core Values</span>
            </Fragment>
          )}
        </h2>
        <div className="banner1-container19">
          <div className="banner1-container20">
            <h3 className="banner1-text19">
              {props.heading6 ?? (
                <Fragment>
                  <span className="banner1-text37">Integrity</span>
                </Fragment>
              )}
            </h3>
            <p className="banner1-text20">
              {props.text5 ?? (
                <Fragment>
                  <span className="banner1-text28">
                    We maintain transparency and honesty in all our operations
                    and interactions.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="banner1-container21">
            <h3 className="banner1-text21">
              {props.heading7 ?? (
                <Fragment>
                  <span className="banner1-text29">Excellence</span>
                </Fragment>
              )}
            </h3>
            <p className="banner1-text22">
              {props.text6 ?? (
                <Fragment>
                  <span className="banner1-text39">
                    We aim for the highest standards in service, performance,
                    and client satisfaction.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="banner1-container22">
            <h3 className="banner1-text23">
              {props.heading8 ?? (
                <Fragment>
                  <span className="banner1-text30">Innovation</span>
                </Fragment>
              )}
            </h3>
            <p className="banner1-text24">
              {props.text7 ?? (
                <Fragment>
                  <span className="banner1-text27">
                    We continuously improve processes to make business
                    management smarter and more efficient.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="banner1-container23">
            <h3 className="banner1-text25">
              {props.heading9 ?? (
                <Fragment>
                  <span className="banner1-text31">Client Focus</span>
                </Fragment>
              )}
            </h3>
            <p className="banner1-text26">
              {props.text8 ?? (
                <Fragment>
                  <span className="banner1-text35">
                    We put our clients’ needs at the center of everything we do,
                    providing personalized solutions.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="banner1-container24">
          <a href="tel:+971555488775">
            <span className="banner1-link2">
              {props.text1 ?? (
                <Fragment>
                  <span className="banner1-text38">
                    {' '}
                    Work With Us
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </Fragment>
              )}
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

Banner1.defaultProps = {
  text7: undefined,
  text5: undefined,
  heading7: undefined,
  heading8: undefined,
  heading9: undefined,
  heading2: undefined,
  text3: undefined,
  heading5: undefined,
  text8: undefined,
  text4: undefined,
  heading6: undefined,
  text1: undefined,
  text6: undefined,
  heading3: undefined,
  heading: undefined,
  heading4: undefined,
  text2: undefined,
  text: undefined,
}

Banner1.propTypes = {
  text7: PropTypes.element,
  text5: PropTypes.element,
  heading7: PropTypes.element,
  heading8: PropTypes.element,
  heading9: PropTypes.element,
  heading2: PropTypes.element,
  text3: PropTypes.element,
  heading5: PropTypes.element,
  text8: PropTypes.element,
  text4: PropTypes.element,
  heading6: PropTypes.element,
  text1: PropTypes.element,
  text6: PropTypes.element,
  heading3: PropTypes.element,
  heading: PropTypes.element,
  heading4: PropTypes.element,
  text2: PropTypes.element,
  text: PropTypes.element,
}

export default Banner1
